module.exports = __webpack_public_path__ + "static/media/delete-black.3528a7d5.svg";